export enum SinglePlanFeatureFlagVariants {
  QuoteTvOptimisation = 'quote-tv-optimisation',
}
